module.exports = __webpack_public_path__ + "static/img/menu5.dd638776.png";